import { render, staticRenderFns } from "./StoriesArchiveView.vue?vue&type=template&id=727be005&"
import script from "./StoriesArchiveView.vue?vue&type=script&lang=ts&"
export * from "./StoriesArchiveView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports